import { render } from "./OrgMessagePage.vue.js?vue&type=template&id=563d5bde!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgMessagePage.vue?vue&type=template&id=563d5bde"
import script from "./OrgMessagePage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgMessagePage.vue?vue&type=script&lang=js"
export * from "./OrgMessagePage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgMessagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/OrgMessagePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "563d5bde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('563d5bde', __exports__)) {
    api.reload('563d5bde', __exports__)
  }
  
  module.hot.accept("./OrgMessagePage.vue.js?vue&type=template&id=563d5bde!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgMessagePage.vue?vue&type=template&id=563d5bde", () => {
    api.rerender('563d5bde', render)
  })

}


export default __exports__